'use client';

import { useTranslations } from 'next-intl';
import { Button } from '../../../components/button';
import { Tooltip } from '../../../components/tooltip';

export type InternalNetworkSignalSetupButtonProps = {
  isAvailable: boolean;
  onOpen: () => void;
  isLoading?: boolean;
  alwaysShow?: boolean;
  label?: 'setup' | 'manage';
  size?: 'xs' | 'sm' | 'md';
  variant?: 'outline' | 'solid' | 'ghost';
};

export function InternalNetworkSignalSetupButton({
  isAvailable,
  onOpen,
  isLoading,
  alwaysShow,
  label = 'setup',
  size = 'xs',
  variant = 'outline',
}: InternalNetworkSignalSetupButtonProps) {
  const t = useTranslations(
    'designSystem.networkSettings.internalScope.attackPath.signalSetup',
  );
  const isHidden = !alwaysShow && (!isAvailable || isLoading);

  if (isHidden) {
    return null;
  }

  const isDisabled = !isAvailable || !!isLoading;
  const button = (
    <Button
      size={size}
      variant={variant}
      disabled={isDisabled}
      onClick={onOpen}
    >
      {label === 'manage' ? t('manageAction') : t('setupAction')}
    </Button>
  );

  if (isDisabled) {
    return (
      <Tooltip title={t('unavailable')}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
}
